<script>import { goto } from "$app/navigation";
import { page } from "$app/stores";
import ReferralIconAnimated from "../icons/referral.svelte";
import { menuAutoCollapsed, menuMobileOpen } from "../state";
import { GameCategory } from "@infinitro/catalog-min";
import {
  cfgToThemeCdnPath,
  formatBaseCurrency,
  stateTheme,
  stateUi,
  Theme
} from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import {
  isBetbyDisplayed,
  isMobile,
  loggedIn,
  ModalDialog,
  parseUtcTimestamp,
  pushModal,
  stateBetbyPage,
  stateRaces,
  stateShowSidebarMobile,
  toCamelCase,
  toSiteUrl,
  toSiteUrlWithActive
} from "@infinitro/global";
import { LocalIcon, RemoteIcon, TransparencyIcon } from "@infinitro/icons";
import { onDestroy, onMount } from "svelte";
import { get } from "svelte/store";
import { getJackpotMEGA } from "../state";
export let category;
export let isSearchModal = false;
export let selectSection = () => null;
export let padding = null;
export let activeSection = "";
export let isMenuCollapsed = false;
export let itemIdPrefix = "";
const theme = get(stateTheme);
const jackpotMEGA$ = getJackpotMEGA();
let hover = false;
let active = false;
let href = "";
let isScrolling = false;
let showPrize = true;
let countdown = "";
let toggleInterval = null;
let countdownInterval = null;
let isTransitioning = false;
let isInitialized = false;
const isSportsCategory = category.href.startsWith("/sports");
const isFlushRaces = category.id === "flush-races";
if (!category.href.startsWith("/")) href = `/${category.href}`;
[href, active] = toSiteUrlWithActive(category.href, `${$page.url.pathname}${$page.url.hash}`);
if (category.external) {
  href = category.href;
  active = false;
}
function getActiveRace() {
  if (!$stateRaces || $stateRaces.length === 0) return null;
  const now = Date.now();
  return $stateRaces.find((race) => {
    const start = parseUtcTimestamp(race.startDate);
    const end = parseUtcTimestamp(race.endDate);
    return now >= start && now <= end;
  });
}
function calculateCountdown() {
  const activeRace2 = getActiveRace();
  if (!activeRace2) {
    countdown = "";
    return;
  }
  const endTime = parseUtcTimestamp(activeRace2.endDate);
  const now = Date.now();
  const diffMs = endTime - now;
  if (diffMs <= 0) {
    countdown = "";
    return;
  }
  const totalSeconds = Math.floor(diffMs / 1e3);
  const days = Math.floor(totalSeconds / 86400);
  const remDay = totalSeconds % 86400;
  const hours = Math.floor(remDay / 3600);
  const remHour = remDay % 3600;
  const minutes = Math.floor(remHour / 60);
  const seconds = remHour % 60;
  const dd = days > 0 ? `${days}d ` : "";
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");
  countdown = `${dd}${hh}:${mm}:${ss}`;
}
$: activeRace = getActiveRace();
$: prizePoolText = activeRace ? formatBaseCurrency(activeRace.prizePool, true) : "";
const handleTouchMove = () => {
  isScrolling = true;
  if ($stateShowSidebarMobile === true) {
    document.body.classList.add("is-scrolling");
  }
};
const handleTouchEnd = () => {
  setTimeout(() => {
    isScrolling = false;
    if ($stateShowSidebarMobile === true) {
      document.body.classList.remove("is-scrolling");
    }
  }, 100);
};
const link_over = () => {
  if (!isScrolling && !useAlternative4) {
    hover = true;
  }
};
const link_out = () => {
  hover = false;
};
const click = (event) => {
  if (isScrolling) return;
  if (!$loggedIn && category.authed) {
    event.preventDefault();
    pushModal(ModalDialog.Auth, { tab: "signup" });
    return;
  }
  if (category.action) {
    event.preventDefault();
    category.action();
    return;
  }
  if (isSportsCategory) {
    event.preventDefault();
    const relPath = category.href.substring(7);
    const href2 = toSiteUrl(category.href, $loggedIn);
    if ($isBetbyDisplayed) {
      window.history.pushState({}, "", href2);
      stateBetbyPage.set(relPath);
    } else {
      goto(href2);
    }
    if ($isMobile) {
      menuMobileOpen.set(false);
    }
  } else {
    active = true;
    if ($isMobile) {
      menuMobileOpen.set(false);
    }
  }
};
menuAutoCollapsed.subscribe((value) => {
  isMenuCollapsed = value;
});
$: {
  if (!isSearchModal) {
    if (!category.href.startsWith("/")) href = `/${category.href}`;
    [href, active] = toSiteUrlWithActive(
      category.href,
      `${$page.url.pathname}${$page.url.hash}`,
      $loggedIn
    );
    if (category.external) {
      href = category.href;
      active = false;
    }
    if (category.id === "promotions" && $page.url.pathname.includes("promotion-page") && !$page.url.pathname.includes("flush-races")) {
      active = true;
    }
  }
}
$: isSelected = isSearchModal && activeSection === category.href;
$: isActive = isSearchModal ? isSelected : active;
$: useAlternative = $stateUi.sidebar.sidebarStyle === "alternative";
$: useAlternative2 = $stateUi.sidebar.sidebarStyle === "alternative2";
$: useAlternative4 = $stateUi.sidebar.sidebarStyle === "alternative4";
$: flushRacesBg = (() => {
  if (!isFlushRaces) return null;
  if ($isMobile) return cfgToThemeCdnPath("/sidebar/races-bg-mobile.png");
  return isMenuCollapsed ? cfgToThemeCdnPath("/sidebar/races-bg-collapsed.png") : cfgToThemeCdnPath("/sidebar/races-bg.png");
})();
onMount(() => {
  if ($isMobile) {
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);
  } else {
    const element = document.getElementById(itemDomId);
    if (element) {
      element.addEventListener("mouseenter", link_over);
      element.addEventListener("mouseleave", link_out);
    }
  }
  if (!isSearchModal) {
    const currentPath = `${$page.url.pathname}${$page.url.hash}`;
    const [_, isActive2] = toSiteUrlWithActive(category.href, currentPath, $loggedIn);
    active = isActive2;
  }
  if (isFlushRaces) {
    calculateCountdown();
    setTimeout(() => {
      isInitialized = true;
    }, 50);
    countdownInterval = setInterval(calculateCountdown, 1e3);
    toggleInterval = setInterval(() => {
      isTransitioning = true;
      setTimeout(() => {
        showPrize = !showPrize;
        setTimeout(() => {
          isTransitioning = false;
        }, 50);
      }, 300);
    }, 1e4);
  }
});
onDestroy(() => {
  if ($isMobile) {
    window.removeEventListener("touchmove", handleTouchMove);
    window.removeEventListener("touchend", handleTouchEnd);
  }
  if (toggleInterval) clearInterval(toggleInterval);
  if (countdownInterval) clearInterval(countdownInterval);
});
const NO_REPLACE = /* @__PURE__ */ new Set(["VipIcon"]);
$: itemDomId = itemIdPrefix ? `${itemIdPrefix}-${toCamelCase(category.name)}` : toCamelCase(category.name);
</script>

<div
	class="container container-search {isMenuCollapsed && !isSearchModal
		? 'container-collapsed'
		: ''}"
	class:flush-races-container={isFlushRaces}
	style="padding-left: {padding}"
>
	<div
		class:indicator={isActive}
		class:indicator-alternative={isActive && (useAlternative || useAlternative4)}
		class:indicator-alternative-2={isActive && useAlternative2}
		class:indicator-alternative-4={isActive && useAlternative4}
		class:indicator-collapsed={isActive && isMenuCollapsed && !isSearchModal}
	></div>
	{#if isSearchModal}
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div
			id={itemDomId}
			class="item item-search {isActive ? 'active' : ''} {hover ? 'hover' : ''} {category.disabled
				? 'disabled'
				: ''}"
			class:alternative-search-item={useAlternative || useAlternative4}
			on:click={category.disabled ? null : () => selectSection(category.href)}
		>
			<span
				class="icon"
				class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
				class:is-active={isActive}
			>
				{#if category.id === 'transparency'}
					<TransparencyIcon size={category?.iconSize ?? 20} bind:hover active={isActive} />
				{:else}
					<RemoteIcon
						icon={category.icon}
						size={category?.iconSize ?? 20}
						bind:hover
						active={isActive}
						replaceFill={!NO_REPLACE.has(category.icon ?? '') &&
							$stateUi.layout.useCurrentColorSidebar}
					/>
				{/if}
			</span>
			<span
				class="text text-search {isActive || hover ? 'active' : ''} {category.disabled
					? 'disabled'
					: ''}">{$t(category.name)}</span
			>
		</div>
	{:else}
		<a
			id={itemDomId}
			{href}
			class:item-link-alternative={useAlternative || useAlternative4}
			class:item-link-alternative-4={useAlternative4}
			class="item-link {category.disabled ? 'disabled' : ''} {hover ? 'hover' : ''}"
			class:flush-races-link={isFlushRaces}
			style={isFlushRaces && flushRacesBg ? `background-image: url(${flushRacesBg})` : ''}
			on:pointerenter={!$isMobile ? link_over : null}
			on:pointerleave={!$isMobile ? link_out : null}
			on:click={click}
			aria-disabled={category.disabled}
			rel={category.external ? 'external' : ''}
		>
			<div
				class="item {category.disabled ? 'disabled' : ''}"
				class:hover={hover && !useAlternative4}
				class:active={isActive && !useAlternative4}
				class:alternative-item={useAlternative || useAlternative4}
				class:flush-races-item={isFlushRaces}
			>
				<span
					class="icon"
					class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
					class:is-active={isActive}
				>
					{#if useAlternative4 && !isSportsCategory}
						<LocalIcon size={category?.iconSize ?? 20} icon={category.icon} />
					{:else if category.id === 'referral' && $stateUi.layout.useReferralIconAnimated}
						<ReferralIconAnimated size={category?.iconSize ?? 20} bind:hover active={isActive} />
					{:else if category.id === 'transparency'}
						<TransparencyIcon size={category?.iconSize ?? 20} bind:hover active={isActive} />
					{:else}
						<RemoteIcon
							icon={category.icon ?? ''}
							size={category?.iconSize ?? 20}
							bind:hover
							active={isActive && !useAlternative4}
							replaceFill={!NO_REPLACE.has(category.icon ?? '') &&
								$stateUi.layout.useCurrentColorSidebar}
						/>
					{/if}
				</span>
				<span
					class="text {category.disabled ? 'disabled' : ''}"
					class:active={(isActive || hover) && !useAlternative4}
					class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
					class:flush-races-text={isFlushRaces && prizePoolText && countdown}
					class:text-hidden={isMenuCollapsed && !isSearchModal}
				>
					{$t(category.name)}
					{#if isFlushRaces && prizePoolText && countdown}
						<span class="highlight-container">
							<span
								class="highlight-text"
								class:visible={showPrize && isInitialized && !isTransitioning}
								class:slide-out={isTransitioning && showPrize}
								class:hidden-above={!showPrize}
							>
								{prizePoolText}
							</span>
							<span
								class="highlight-text"
								class:visible={!showPrize && isInitialized && !isTransitioning}
								class:slide-out={isTransitioning && !showPrize}
								class:hidden-above={showPrize}
							>
								{countdown}
							</span>
						</span>
					{/if}
				</span>
				{#if category.name === Verbiage.FOMO_jackpot}
					<span
						class="badge"
						class:badge-alternative={useAlternative || useAlternative4}
						class:text-hidden={isMenuCollapsed && !isSearchModal}
					>
						{$jackpotMEGA$}
					</span>
				{/if}
			</div>
			{#if isFlushRaces && !isMenuCollapsed}
				<img
					src={cfgToThemeCdnPath('/sidebar/races-bg-illustration.png')}
					alt={$t(Verbiage.races_banner_alt)}
					class="races-illustration"
				/>
			{/if}
		</a>
	{/if}
</div>

<style>
	.badge {
		border-radius: 0.75rem;
		background-color: var(--color-primary-500);
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		padding-top: 1px;
		padding-bottom: 1px;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity));
		font-size: 0.75rem;
		line-height: 1rem;
}
	@media (min-width: 1024px) {
		.badge {
				font-size: 10px;
		}
}
	.badge {
		overflow: hidden;
		max-width: 100px;
		transition:
			opacity 0.15s ease,
			max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.badge.text-hidden {
		opacity: 0;
		max-width: 0;
		pointer-events: none;
	}

	.badge-alternative {
		color: var(--color-text-100);
}

	.container {
		position: relative;
		display: flex;
		align-items: center;
		font-weight: 400;
}

	.container-collapsed {
		width: 100%;
}

	.container-search {
		margin-top: -2px;
		margin-bottom: -2px;
		width: 100%;
}

	.flush-races-container {
		padding: 0 !important;
		height: 42px !important;
	}

	.indicator {
		position: absolute;
		left: -15px;
		height: 100%;
		width: 5px;
		border-top-right-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem;
		background: var(--gradient-primary);
		box-shadow: 0 0 3px 3px color-mix(in srgb, var(--color-primary-100) 20%, transparent);
}

	.indicator-alternative {
		background-color: var(--color-primary-500);
		box-shadow: unset;
		background-image: unset;
}

	.indicator-alternative-2 {
		background: linear-gradient(180deg, var(--color-primary-500) 0%, var(--color-primary-700) 100%);
	}

	.indicator-alternative-4 {
		background-color: var(--component-side-bar-dropdown-side-bar-item-bg);
		border-radius: 0;
		left: -15px;
		right: -30px;
		z-index: -1;
		width: unset;
	}

	.indicator-collapsed {
		left: -28px;
}

	a.item-link {
		display: flex;
		width: 100%;
		border-radius: 14px;
		font-size: 14px;
		font-family: var(--font-main);

		&.disabled {
				pointer-events: none;
		}

		&.disabled {
				cursor: not-allowed;
		}

		&.disabled {
				opacity: 0.5;
		}

		&.hover,
		&:hover {
				color: var(--color-text-100);
		}
}

	a.flush-races-link {
		position: relative;
		height: 100%;
		width: 100%;
		overflow: hidden;
		border-radius: 10px;
		background-size: cover;
		background-repeat: no-repeat;
		padding-left: 12px;
		border: 1px solid var(--color-primary-100);
}

	a.flush-races-link .item {
		height: 100%;
		color: var(--color-text-100) !important;
		opacity: 90%;
		&.active,
		&.hover,
		&:hover {
			opacity: 100%;
		}
}

	.races-illustration {
		position: absolute;
		right: 0px;
		height: 100%;
}

	a.item-link-alternative {
		&.hover,
		&:hover {
				color: var(--color-primary-500);
		}

		& span.text.active {
				color: var(--color-primary-500);
		}

		& > .item.active,
		& > .item.hover,
		& > .item:hover {
				color: var(--color-primary-500);
		}
	}

	a.item-link-alternative-4 {
		&.hover,
		&:hover {
				color: unset;
		}

		& span.text.active {
				color: unset;
		}

		& > .item.active,
		& > .item.hover,
		& > .item:hover {
				color: unset;
		}
	}

	div.item {
		display: flex;
		cursor: pointer;
		flex-wrap: nowrap;
		align-items: center;
		gap: 0.25rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		color: var(--color-text-300);

		&.disabled {
				cursor: not-allowed;
		}

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity));
		}

		&.hover,
		&:hover {
				color: var(--color-text-100);
		}

		&.active {
				color: var(--color-text-100);
		}
}

	div.alternative-item {
		color: var(--color-text-100);
}

	div.alternative-search-item {
		opacity: 0.5;
}

	span.icon {
		display: flex;
		min-height: 20px;
		min-width: 20px;
		align-items: center;
		justify-content: center;
		padding-bottom: 2px;
}

	span.text {
		margin-left: 0.25rem;
		height: 20px;
		flex: 1 1 0%;
		white-space: nowrap;
		font-size: 14px;
		overflow: hidden;
		max-width: 200px;
		transition:
			opacity 0.15s ease,
			max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
			margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1);

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity));
		}

		&.hover,
		&:hover {
				color: var(--color-text-100);
		}

		&.active {
				color: var(--color-text-100);
		}
}

	span.text.text-hidden {
		opacity: 0;
		max-width: 0;
		margin-left: 0;
		pointer-events: none;
	}

	span.text-search {
		font-size: 12px;
		text-transform: uppercase;
		font-family: var(--font-main);
}

	div.item-search {
		display: flex;
		align-items: center;
		border-radius: 14px;
		font-size: 12px;
		font-weight: 600;
		text-transform: uppercase;
		font-family: var(--font-main);

		&.hover,
		&:hover {
				opacity: 1;
		}

		&.active {
				opacity: 1;
		}
}

	div.item-search:hover,
	div.item-search.active {
		opacity: 1;
}

	span.text.not-auto-fill {
		font-weight: 600;
	}

	span.icon.not-auto-fill {
		opacity: 0.7;
}

	a.flush-races-link .item span.icon.not-auto-fill {
		opacity: 1;
}

	span.icon.not-auto-fill.is-active,
	.item.hover span.icon.not-auto-fill,
	.item-search.hover span.icon.not-auto-fill {
		opacity: 1;
}

	div.flush-races-item {
		position: relative;
		padding-top: 0px;
		padding-bottom: 0px;
}

	.flush-races-text {
		position: absolute;
		left: 24px;
		top: 2px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		height: auto !important;
		overflow: visible !important;
}

	.highlight-container {
		position: relative;
		height: 0.7rem !important;
		min-height: 0.7rem !important;
		width: 80px;
		display: block !important;
}

	.highlight-text {
		position: absolute;
		left: 0px;
		top: 0px;
		font-size: 0.7rem;
		color: var(--color-highlight-1);
		transition:
			transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
			opacity 0.6s ease;
		opacity: 0;
}

	.highlight-text.visible {
		opacity: 1 !important;
		transform: translateY(0) !important;
	}

	.highlight-text.slide-out {
		transform: translateY(100%);
		opacity: 0;
	}

	.highlight-text.hidden-above {
		transform: translateY(-100%);
		opacity: 0;
	}
</style>
